import { Card } from 'entities/card/model/types';
import { api } from 'shared/api';
import { ApiResponse } from 'shared/model/types';

const _api = api.injectEndpoints({
  endpoints: (build) => ({
    signVirtualCard: build.mutation<ApiResponse<Card>, { password: string, accountId: number }>({
      query: ({ password, accountId }) => ({
        url: `private/river/${accountId}/card/virtual/sign`,
        method: 'POST',
        body: {
          password
        }
      }),
      invalidatesTags: ['accounts']
    })
  })
});

export const {
  useSignVirtualCardMutation
} = _api;